import React from 'react';
import ReactDOM from 'react-dom';
import trackLink from '@99designs/common/utils/platform/trackLink';
import { EVENT_CLICKED_INVITE_BUTTON } from 'apps/find-designers/consts';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Button } from '@99designs/common/components/Button';
import { ButtonGroup, ButtonGroupItem } from '@99designs/common/components/ButtonGroup';
import FavoriteButton from 'components/FavoriteButton';

class DesignerActions extends React.Component {
    componentDidMount() {
        this.trackInviteClick();
    }

    trackInviteClick() {
        trackLink(
            ReactDOM.findDOMNode(this.inviteButton), // eslint-disable-line react/no-find-dom-node
            EVENT_CLICKED_INVITE_BUTTON,
            {
                designer_id: this.props.designerId,
            }
        );
    }

    favoriteGroupItem() {
        if (!this.props.canFavorite) return null;

        return (
            <ButtonGroupItem>
                <FavoriteButton
                    isFavorite={this.props.isFavorite}
                    favoriteUrl={this.props.urls.favoriteUrl}
                />
            </ButtonGroupItem>
        );
    }

    render() {
        return (
            <ButtonGroup>
                {this.favoriteGroupItem()}
                <ButtonGroupItem>
                    <Button
                        variations={['small', 'secondary']}
                        href={this.props.urls.inviteUrl}
                        ref={element => {
                            this.inviteButton = element;
                        }}
                    >
                        <FormattedMessage id="invite" />
                    </Button>
                </ButtonGroupItem>
            </ButtonGroup>
        );
    }
}

DesignerActions.defaultProps = {
    favoriteUrl: false,
    isFavorite: false,
    onInviteClick: () => undefined,
};

DesignerActions.propTypes = {
    urls: PropTypes.shape({
        inviteUrl: PropTypes.string.isRequired,
        favoriteUrl: PropTypes.string,
    }).isRequired,
    isFavorite: PropTypes.bool,
    canFavorite: PropTypes.bool.isRequired,
    designerId: PropTypes.number.isRequired,
};

export default DesignerActions;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Listing/DesignerActions.jsx